module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedExtraLight.07c55fe.woff2";